




















































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import dialogViewVenta from '@/components/dialogViewVenta.vue'
import HTTP from '@/plugins/axios'
import moment from 'moment'
moment.locale('es-MX')

@Component ({
  components: {
    dialogViewVenta
  }
})
export default class ViewVentas extends Vue {
  private name: string = 'ViewVentas'
  private search: string = ''
  private menu1: boolean = false
  private date = new Date().toISOString().substr(0, 10)
  private infoVenta: object = {}
  private tableVenta: any[] = []
  private tableBoletos: any[] = []
  private metodoPagoSelected: string = ''
  private metodoPago: any[] = [
    {
      text: 'Ninguno',
      id: null
    },
    {
      text: 'OXXO CASH',
      id: 'oxxo_cash'
    },
    {
      text: 'Tarjeta Credito/Debito',
      id: 'card'
    },
    {
      text: 'NA (No Aplica / No Pago)',
      id: 'NA'
    }
  ]
  private optSelected: number = 0
  private resumenBoletos: any[] = []
  private statusBoletoSelected: any = null
  private transaccionSelected: string = null
  private taquillaSelected: string = null
  private boletoTipoSelected: string = null
  private boletoMetodoPagoSelected: string = null
  private boletoBusquedaFolioSelected: string = null

  private boletoFilter: any[] = []
  private optionStatusBoleto: any = [
    {
      text: 'Todos',
      value: null
    },
    {
      text: 'Pagados',
      value: 'paid'
    },
    {
      text: 'Por Pagar',
      value: 'pending_payment'
    },
    {
      text: 'Declinado',
      value: 'declined'
    },
    {
      text: 'Expirados',
      value: 'expired'
    },
    {
      text: 'Erroneos',
      value: 'erroneos'
    }
  ]
  private fechaBusqueda: any = null

  private optionCategoriaBoletos: any[] = []
  private optionCategoriaBoletosBase: any = {
    text: 'Todos',
    value: null
  }

  private headers: any[] = [
    {
      text: 'Fecha',
      align: 'left',
      sortable: true,
      value: 'createdAt'
    },
    { text: 'ID Venta', value: 'id' },
    { text: 'Comprador', value: 'buyerName' },
    { text: 'Boletos', value: 'boleto' },
    { text: 'Metodo de Pago', value: 'paymentMethod' },
    { text: 'Monto', value: 'amountTotal' },
    { text: 'OrderConekta', value: 'idOrder' },
    { text: 'Status', value: 'paymentStatus' },
    { text: 'StatusConekta', value: 'statusConekta' },
    { text: 'Acciones', value: 'acciones' }
  ]

  private headersBoleto: any[] = [
    {
      text: 'Fecha',
      align: 'left',
      sortable: true,
      value: 'createdAt'
    },
    { text: 'Venta', value: 'venta.id' },
    { text: 'Folio', value: 'folio' },
    { text: 'Folio Encriptado', value: 'folioEncrypted' },
    { text: 'Tipo', value: 'boleto.name' },
    { text: 'Metodo de Pago', value: 'venta.paymentMethod' },
    { text: 'Pagado', value: 'pagado' },
    { text: 'Acciones', value: 'acciones' }
  ]

  private get tBoletos () {
    console.log('tBoletos :: ')
    let res: any[] = []
    if (
      (this.boletoMetodoPagoSelected === null) &&
      (this.boletoBusquedaFolioSelected === null) &&
      (this.boletoTipoSelected === null) &&
      (this.transaccionSelected === null) &&
      (this.statusBoletoSelected === null) &&
      (this.fechaBusqueda === null)
    ) {
      res = this.tableBoletos
    } else {
      let buscaFolio = null
      let buscaBoleto = null
      let buscaMetodoPago = null
      let buscaFecha = null
      let buscaTransaccion = null
      let buscaStatus: any = null

      let resMetodoPago = null
      let resTransaccion = null
      let resPaymentStatus = null

      console.log('boletoMetodoPagoSelected :: ', this.boletoMetodoPagoSelected)
      console.log('boletoBusquedaFolioSelected :: ', this.boletoBusquedaFolioSelected)
      console.log('boletoTipoSelected :: ', this.boletoTipoSelected)
      console.log('buscaTransaccion :: ', this.transaccionSelected)
      console.log('buscaFecha :: ', this.fechaBusqueda)
      console.log('statusBoletoSelected :: ', this.statusBoletoSelected)

      if (this.boletoBusquedaFolioSelected === '')  this.boletoBusquedaFolioSelected = null
      if (this.transaccionSelected === '')          this.transaccionSelected = null
      if (this.statusBoletoSelected === '')         this.statusBoletoSelected = null

      this.tableBoletos.forEach((boleto) => {
        this.boletoMetodoPagoSelected !== null ? buscaMetodoPago = this.boletoMetodoPagoSelected.toString() : buscaMetodoPago = null
        this.boletoBusquedaFolioSelected !== null ? buscaFolio = this.boletoBusquedaFolioSelected.toString() : buscaFolio = null
        this.boletoTipoSelected !== null ? buscaBoleto = this.boletoTipoSelected.toString() : buscaBoleto = null
        this.transaccionSelected !== null ? buscaTransaccion = this.transaccionSelected.toString() : buscaTransaccion = null
        this.fechaBusqueda !== null ? buscaFecha = this.fechaBusqueda : buscaFecha = null
        this.statusBoletoSelected !== null ? buscaStatus = this.statusBoletoSelected : buscaStatus = null

        if (boleto.venta !== null) {
          if (buscaMetodoPago === null)   buscaMetodoPago = boleto.venta.paymentMethod
          if (buscaTransaccion === null)  buscaTransaccion = boleto.venta.id.toString()
          if (buscaStatus === null)       buscaStatus = boleto.venta.paymentStatus
          resPaymentStatus = boleto.venta.paymentStatus
          resMetodoPago = boleto.venta.paymentMethod
          resTransaccion = boleto.venta.id.toString()

        } else {
          buscaMetodoPago = null
          buscaTransaccion = null

          resMetodoPago = null
          resTransaccion = null
          resPaymentStatus = 'erroneos'
        }

        if (buscaFolio === null)  buscaFolio = boleto.folio
        if (buscaBoleto === null) buscaBoleto = boleto.boleto.id.toString()
        if (buscaFecha === null)  buscaFecha = boleto.createdAt

        console.log(resMetodoPago + ' === ' + buscaMetodoPago)
        console.log(buscaFolio + ' === ' + boleto.folio)
        console.log(buscaBoleto + ' === ' + boleto.boleto.id.toString())
        console.log(buscaTransaccion + ' === ' + resTransaccion)
        console.log(buscaStatus + ' === ' + resPaymentStatus)
        if (
          (resMetodoPago === buscaMetodoPago) &&
          (buscaFolio === boleto.folio) &&
          (buscaBoleto === boleto.boleto.id.toString()) &&
          (buscaTransaccion === resTransaccion) &&
          (buscaStatus === resPaymentStatus) &&
          (moment(buscaFecha).format('YYYY-MM-DD') === moment(boleto.createdAt).format('YYYY-MM-DD'))
        ) {
          res.push(boleto)
        }
      })
    }

    this.boletoFilter = []
    this.boletoFilter = res

    console.log('res :: ', res)
    return res
  }

  private showInfoVenta (item: any) {
    console.log('showInfoVenta :: ', item)
    this.gShowOrder(item.idOrder)
    this.infoVenta = Object.assign({}, item)
  }

  private get tVentas () {
    let res: any[] = []
    if ((this.metodoPagoSelected === '') && (this.search === '') && (this.fechaBusqueda === null)) {
      res = this.tableVenta
    } else {
      this.tableVenta.forEach((venta) => {
        if (
          (venta.buyerName.toUpperCase().search(this.search.toUpperCase()) >= 0 && this.search !== '') ||
          (venta.paymentMethod === this.metodoPagoSelected && this.metodoPagoSelected !== '') ||
          (moment(venta.createdAt).format('YYYY-MM-DD') === moment(this.fechaBusqueda).format('YYYY-MM-DD') && this.fechaBusqueda !== '')
        ) {
          res.push(venta)
        }
      })
    }
    console.log('res :: ', res)
    return res
  }

  private gShowStatusConekta (tableVenta: any[]) {
    console.log('gShowOrder :: ')
    tableVenta.map(async (item: any) => {

      if (item.idOrder === 'NO-CONEKTA') {
        return false
      }

      await setTimeout(async () => {
        // @ts-ignore: Unreachable code error
        HTTP.get('conekta/' + item.idOrder + '/find')
          .then((response) => {
            // console.log('gShowOrder :: response :: ', response.data)
            console.log('gShowOrder :: response :: ', response.data.charges._json.data[0].status)
            item.statusConekta = response.data.charges._json.data[0].status
          })
          .catch((e) => {
            console.log('gShowOrder :: catch :: ', e.response.data)
          })
      }, 2500)
    })
  }

  private gShowOrder (id: string) {
    console.log('gShowOrder :: ')
    if (id === 'NO-CONEKTA') {
      return false
    }

    HTTP.get('conekta/' + id + '/find')
      .then((response) => {
        console.log('gShowOrder :: response :: ', response.data)
        console.log('gShowOrder :: ' + id + ' :: ', response.data.charges._json.data[0].status)
      })
      .catch((e) => {
        console.log('gShowOrder :: catch :: ', e.response.data)
      })
  }

  private resendEmail (item: any) {
    console.log('gShowOrder :: ')
    HTTP.get('conekta/' + item.id + '/resend-email')
      .then((response) => {
        console.log('gShowOrder :: response :: ', response.data)
        this.$store.commit('setSnackbarMsg',  {
          text: 'El email ha sido, re-enviado.',
          color: 'success',
          show: true,
          timeout: 2000
        })
      })
      .catch((e) => {
        console.log('gShowOrder :: catch :: ', e.response.data)
      })
  }

  private closeOXXO () {
    const data = {
      data: {
        object: {
          id: '588258fbedbb6e85e7000f95',
          livemode: false,
          created_at: 1484937467,
          currency: 'MXN',
          payment_method: {
            service_name: 'OxxoPay',
            object: 'cash_payment',
            type: 'oxxo',
            expires_at: 1487548800,
            store_name: 'OXXO',
            reference: '93345678901234'
          },
          details: {
            name: 'Fulanito Pérez',
            phone: '+5218181818181',
            email: 'fulanito@conekta.com',
            line_items: [
              {
                name: 'Tacos',
                unit_price: 1000,
                quantity: 12
              }
            ],
            shipping_contact: {
              phone: '5555555555',
              receiver: 'Bruce Wayne',
              address: {
                street1: 'Calle 123 int 2 Col. Chida',
                city: 'Cuahutemoc',
                state: 'Ciudad de Mexico',
                country: 'MX',
                postal_code: '06100',
                residential: true
              }
            },
            object: 'details'
          },
          object: 'charge',
          status: 'paid',
          amount: 13500,
          paid_at: 1484937498,
          fee: 1421,
          customer_id: '',
          order_id: 'ord_2mSME5f7b1A1HysDt'
        },
        previous_attributes: {
          status: 'pending_payment'
        }
      },
      livemode: false,
      webhook_status: 'successful',
      webhook_logs: [
        {
          id: 'webhl_2fshi2CmCGqx4p6go',
          failed_attempts: 0,
          last_http_response_status: 200,
          object: 'webhook_log',
          last_attempted_at: 1484937503
        }
      ],
      id: '5882591b5906e7819c0007f1',
      object: 'event',
      type: 'charge.paid',
      created_at: 1484937499
    }

    const data2 = {
      id: '51cef9faf23668b1f4000001',
      created_at: 1570205842,
      livemode: true,
      type: 'ping',
      data: {
        object: {},
        previous_attributes: {}
      }
    }

    HTTP.post('conekta/confirm-oxxo/', data2)
      .then((response) => {
        console.log('closeOXXO :: response :: ', response.data)
      })
      .catch((e) => {
        console.log('closeOXXO :: catch :: ', e.response.data)
      })
  }

  private viewPDF (item: any) {
    console.log('gShowOrder :: ')
    HTTP.get('conekta/' + item.id + '/view-pdf')
      .then((response) => {
        console.log('gShowOrder :: response :: ', response.data)
        window.open(process.env.VUE_APP_AXIOS_BASE_URL + 'conekta/pdf/' + response.data, '_blank')
      })
      .catch((e) => {
        console.log('gShowOrder :: catch :: ', e.response.data)
      })
  }

  private gShowAllVentas () {
    console.log('gShowAllVentas :: ')
    HTTP.get('venta/')
      .then((response) => {
        console.log('gShowAllVentas :: response :: ', response.data)
        this.tableVenta = response.data
        this.tableVenta.forEach((item: any) => {
          item.statusConekta = item.paymentStatus
        })
      })
      .catch((e) => {
        console.log('gShowAllRol :: catch :: ', e.response.data)
      })
  }

  private gShowAllBoletos () {
    console.log('gShowAllBoletos :: ')
    HTTP.get('vendido/')
      .then((response) => {
        console.log('gShowAllBoletos :: response :: ', response.data)
        this.tableBoletos = response.data
      })
      .catch((e) => {
        console.log('gShowAllBoletos :: catch :: ', e.response.data)
      })
  }

  private gResumenBoletos () {
    console.log('gResumenBoletos :: ')
    HTTP.get('boleto/')
      .then((response) => {
        console.log('gResumenBoletos :: response :: ', response.data)
        this.resumenBoletos = response.data
        this.optionCategoriaBoletos = []
        this.optionCategoriaBoletos.push(this.optionCategoriaBoletosBase)
        this.resumenBoletos.forEach((bole: any) => {
          console.log('bole:: bole :: ', bole)
          this.optionCategoriaBoletos.push({
            text: bole.name,
            value: bole.id
          })
        })
        console.log('optionCategoriaBoletos :: ', this.optionCategoriaBoletos)
      })
      .catch((e) => {
        console.log('gResumenBoletos :: catch :: ', e.response.data)
      })
  }

  private beforeMount () {
    console.log('beforeMount :: ', this.name)
    this.gShowAllVentas ()
    this.gShowAllBoletos()
    this.gResumenBoletos()
    // this.closeOXXO ()
  }
}
